<app-dialog 
	[title]="data.type === 'New' ? 'Add new warehouse' : 'Edit warehouse'" 
	[actions]="[
		{ text: 'Cancel', buttonStyle: 'underline' },
		{
			text: data.type === 'New' ? 'Save' : 'Update',
			isDisabled: this.warehouseForm.invalid
		}
	]" 
	(action)="dialogAction($event)" 
	(close)="dialogRef.close()" 
	class="edit_ware_block"
>
	<mat-dialog-content>
		<form class="warehouse" [formGroup]="warehouseForm" autocomplete="off">
			<div class="input-container">
				<label for="" class="input-container_label">ID
					<!-- <span class="input-container_asterisk">*</span> -->
				</label>
				<input class="input-container_input" type="text" formControlName="Name"
					[readonly]="data.type === 'edit'" />
					<!-- (keyup)="checkId($event)" -->
				<!-- <i class="fal fa-check primary_color" *ngIf="uniqueId && checkedUniqueId"></i>
				<i class="fal fa-times danger_color" *ngIf="!uniqueId && checkedUniqueId && !loadingUniqueId"></i>
				<i class="fal fa-sync fa-spin primary_color" *ngIf="loadingUniqueId"></i>&nbsp;&nbsp;
				<small *ngIf="!uniqueId && checkedUniqueId" class="danger_color">Warehouse name is not available</small> -->
			</div>
			<div class="input-container gap_bottom_10 gap_top_1pt5" style="grid-column: span 2 / span 2;">
				<label class="input-container_label" for="">Address Name
					<!-- <span class="input-container_asterisk">*</span> -->
				</label>
				<input class="input-container_input" type="text" formControlName="AddressName" />
			</div>
			<div class="input-container gap_bottom_10 gap_top_1pt5" style="grid-column: span 2 / span 2;">
				<label class="input-container_label" for="">Address
					<!-- <span class="input-container_asterisk">*</span> -->
				</label>
						<input
							type="text"
							class="input-container_input"
							formControlName="AddressLine"
							#addressText
						/>
				<!-- <input class="input-container_input" type="text" formControlName="AddressLine" placeholder="Street"/> -->
			</div>
			<div class="input-container gap_bottom_10 gap_top_1pt5" style="grid-column: span 2 / span 2;">
				<label class="input-container_label" for="">Address Line #2:</label>
				<input class="input-container_input" type="text" formControlName="AddressLine2" placeholder="Address Line2"/>
			</div>
			<!-- <div class="input-container gap_bottom_10 gap_top_3pt5">
				<label class="input-container_label" for="">Address Line #2:</label>
				<input class="input-container_input" type="text" formControlName="City" placeholder="City"/>
			</div>
			<div class="input-container gap_bottom_10 gap_top_1pt5">
				<label class="input-container_label" for="">Country:<span
						class="input-container_asterisk">*</span></label>
				<mat-form-field appearance="fill" class="mat-select-control mat-select-lg w-100">
					<mat-select id="Country" formControlName="CountryCode" placeholder="Country">
						<mat-option [value]="'US'"> United States </mat-option>
						<mat-option [value]="'CA'"> Canada </mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			

			<div class="input-container gap_bottom_10 gap_top_1pt5">
				<label class="input-container_label">Zip:<span class="input-container_asterisk">*</span></label>
				<input class="input-container_input" type="text" readonly formControlName="CountryCode" placeholder="Country Code"/>
			</div>
			<div class="input-container gap_bottom_10 gap_top_1pt5">
				<label class="input-container_label" for="">State<span
						class="input-container_asterisk">*</span></label>
				<mat-form-field appearance="fill" class="mat-select-control mat-select-lg w-100">
					<mat-select id="State" formControlName="State" placeholder="State">
						<mat-option [value]="state.abbreviation" *ngFor="let state of states">
							{{ state.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="input-container gap_bottom_10 gap_top_1pt5">
				<label class="input-container_label">Zip:<span class="input-container_asterisk">*</span></label>
				<input class="input-container_input" numbersOnly formControlName="Zipcode" placeholder="Postal"/>
			</div> -->
			
			<div class="input-container gap_bottom_10 gap_top_1pt5">
				<label for="" class="input-container_label">Priority Level</label>
				<input type="number" class="input-container_input" formControlName="PriorityLavel" min="1" />
			</div>
			<div class="input-container gap_bottom_10 gap_top_1pt5">
				<label for="" class="input-container_label">Pick Strategy</label>
				<mat-form-field appearance="fill" class="mat-select-control mat-select-lg w-100">
					<mat-select id="PickStrategy" formControlName="PickStrategy" placeholder="Select">
						<mat-option [value]="item.name" *ngFor="let item of pickStrategies">
							{{ item.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="input-container gap_top_1pt5" style="grid-column: span 2 / span 2;">
				<div class="checkbox switcher">
					<label for="toggleFBA">
						<input type="checkbox" id="toggleFBA" value="" formControlName="FulfillsFba">
						<span><small></small></span>
						<span class="toggle-label">Fulfills FBA</span>
					</label>
				</div>
			</div>
			<div class="input-container gap_top_1pt5" style="display: flex; align-items: center; grid-column: span 2 / span 2; gap: 40px;">
				<div class="checkbox switcher">
					<label for="toggleFBM">
						<input type="checkbox" id="toggleFBM" value="" formControlName="FulfillsFbm">
						<span><small></small></span>
						<span class="toggle-label">Fulfills FBM</span>
					</label>
				</div>
				<div class="input-container">
					<mat-checkbox formControlName="EnabledLocationsOnly" [disabled]="!warehouseForm.value.FulfillsFbm">Enabled Location Only</mat-checkbox>
				</div>
			</div>
			<div class="input-container gap_top_1pt5" style="grid-column: span 2 / span 2;">
				<div class="checkbox switcher">
					<label for="toggleVc">
						<input type="checkbox" id="toggleVc" value="" formControlName="FulfillsVendorCenter">
						<span><small></small></span>
						<span class="toggle-label">Fulfills Vendor Control</span>
					</label>
				</div>
			</div>
			<div class="input-container gap_top_1pt5" style="grid-column: span 2 / span 2;">
				<div class="checkbox switcher">
					<label for="togglePickingEnabled">
						<input type="checkbox" id="togglePickingEnabled" value="" formControlName="PickingEnabled">
						<span><small></small></span>
						<span class="toggle-label">Picking Enabled</span>
					</label>
				</div>
			</div>
			<!-- <div class="input-container gap_bottom_10 gap_top_1pt5">
				<label class="input-container_label" for="">Priority Level:</label>
				<input class="input-container_input" type="text" formControlName="Priority" />
			</div>
			<div class="fullfilment gap_top_5">
				<p class="font-600">Fullfilment Settings</p>

				<div class="d-flex flex-column gap_top_3">
					<mat-checkbox formControlName="Isfba">FBA</mat-checkbox>
					<mat-checkbox formControlName="Isfbm" class="mt-3">FBM</mat-checkbox>
				</div>
			</div> -->
		</form>
	</mat-dialog-content>

	<!-- <div class="warehouse" [formGroup]="whForm">

		<div class="input-container">
			<label for="" class="input-container_label">ID</label>
			<input type="text" class="input-container_input" />
		</div>
		<div class="input-container">
			<label for="" class="input-container_label">Warehouse name</label>
			<input type="text" class="input-container_input" formControlName="name" />
		</div>
		<div class="input-container" style="grid-column: span 2 / span 2;">
			<label for="" class="input-container_label">Address Name</label>
			<input type="text" class="input-container_input" formControlName="addressName" />
		</div>
		<div class="input-container">
			<label for="" class="input-container_label">Address</label>
			<input type="text" class="input-container_input" formControlName="addressLine"  placeholder="Street"/>
		</div>
		<div class="input-container">
			<label for="" class="input-container_label" style="visibility: hidden;">City</label>
			<input type="text" class="input-container_input" formControlName="city" placeholder="City"/>
		</div>
		<div class="input-container">
			<input type="text" class="input-container_input" formControlName="state" placeholder="State" />
		</div>
		<div class="input-container">
			<input type="text" class="input-container_input" formControlName="postal" placeholder="Postal"/>
		</div>
		<div class="input-container">
			<input type="text" class="input-container_input" formControlName="country" placeholder="Country"/>
		</div>
		<div class="input-container">
			<input type="text" class="input-container_input" formControlName="countryCode" placeholder="Country code"/>
		</div>
		<div class="input-container">
			<label for="" class="input-container_label">Priority lavel</label>
			<input type="number" class="input-container_input" formControlName="priorityLavel" min="0" />
		</div>
		<div class="input-container">
			<label for="" class="input-container_label">Pick strategy</label>
			<input type="number" class="input-container_input" formControlName="pickStrategy" placeholder="Select"
				min="0" />
		</div>
	</div> -->
</app-dialog>